import { Box, Button, Divider, InputLabel, TextField, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import axiosInstance from '../../../api/axiosInstance'
import { useNavigate } from 'react-router-dom'
import { removeData } from '../../../Redux/Feature/AdminSlice'

function ContactUsAdmin() {
  
  const allLanguages = useSelector((state) => state.language.languageList)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const headerDatas = {
    header : '',
    address : '',
    addressLine : [],
    email : '',
    tel : '',
    website : ''
  }

  const bottomDatas = {
    name : '',
    namePlaceHolder : '',
    nameErrorMessage : '',
    dob : '',
    dobErrorMessage : '',
    nationality : '',
    nationalityErrorMessage : '',
    contact_no : '',
    contact_no_placeHolder : '',
    contact_no_errorMessage : '',
    email : '',
    emailPlaceHolder : '',
    emailErrorMessage : '',
    line : '',
    linePlaceholder : '',
    wechat : '',
    wechatPlaceholder : '',
    whatsapp : '',
    whatsappPlaceholder : '',
    other_remarks : '',
    other_remarks_placeholder : '',
    submit : ''
  }

  const [activeLanguagesHeader, setActiveLanguagesHeader] = useState(allLanguages);
  const [activeLanguagesBottomDats, setActiveLanguageBottomDatas] = useState(allLanguages);

  const [contactUsData, setContactUsContent] = useState([])
  const [contactUsId, setContactUsId] = useState('')

  const [header, setHeader] = useState({
    en : { ...headerDatas }
  })

  const [bottomData, setBottomData] = useState({
    en : { ...bottomDatas }
  })

  const addHeaderLanguage = () => {
      const nextLanguage = allLanguages.find(lang => !activeLanguagesHeader.some(active => active.value === lang.value))
      if(nextLanguage){
        setActiveLanguagesHeader((prev) => [...prev, nextLanguage])
        setHeader((prev => ({...prev, [nextLanguage.value] : { ...headerDatas }})))
      }
  }

  const addBottomDatasLanguage = () => {
    const nextLanguage = allLanguages.find(lang => !activeLanguagesBottomDats.some(active => active.value === lang.value))
    if(nextLanguage){
      setActiveLanguageBottomDatas((prev) => [...prev, nextLanguage])
      setBottomData((prev => ({...prev, [nextLanguage.value] : { ...bottomDatas }})))
    }
}

const handleHeadingChange = (e, lang, key) => {
  setHeader((prev) => ({
    ...prev,
    [lang]: {
      ...(prev[lang] || { ...headerDatas }),
      [key]: e.target.value,
    },
  }));
};

const handleBottomDataChange = (e, lang, key) => {
  setBottomData((prev) => ({
    ...prev,
    [lang]: {
      ...(prev[lang] || { ...bottomDatas }),
      [key]: e.target.value,
    },
  }));
};

const getContactUsContent = async () => {
  try {
      const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-contact-us-content`)
      setContactUsContent(response?.data?.data)
  } catch (error) {
      console.log(error)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
  }
}

useEffect(() => {
  getContactUsContent()
}, [])

useEffect(() => {
  if(contactUsData?.length > 0){
      setHeader(contactUsData?.[0]?.header)
      setBottomData(contactUsData?.[0]?.form_values)
      setContactUsId(contactUsData?.[0]?._id)
  }
}, [contactUsData])





const updateContactUsPageContent = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}edit-contact-us-content/${id}`, formData);
    console.log('AboutUs updated successfully:', response);
    getContactUsContent()
  } catch (error) {
    console.error('Error updating AboutUs:', error);
    if(error.response.status === 401 || error.response.status === 403){
      navigate('/Admin/login')
      dispatch(removeData())
  }
  }
};

const handleSubmitEdit = async () => {
  const formData = new FormData();

  // Append fields (conditionally if updated)
  formData.append('header', header);
  formData.append('form_values',bottomData);


  await updateContactUsPageContent(contactUsId, {header, form_values : bottomData});
};

const handleSubmit = async () => {
  if(contactUsData.length > 0){
    handleSubmitEdit()
  }else {
    const formData = new FormData()

    formData.append('header', JSON.stringify(header))
    formData.append('form_values', JSON.stringify(bottomData))
  
    try {
      const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}add-contact-us-content`, {header, form_values : bottomData})
      console.log(response)
      if(response.status === 201){
          console.log(response.data)
          getContactUsContent()
      }
  } catch (error) {
      console.log(error)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
  }
  }
}



  return (
    <div>
      <Typography sx={{fontSize : '1.5rem', fontWeight : 700}}>
        Top Content
      </Typography>
        {activeLanguagesHeader.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', flexDirection : 'column',gap: 2, justifyContent : 'flex-start', mt: 2 }}>
                        <Typography sx={{width : '20%', color : 'black', fontWeight : 700, fontSize : '1.2rem'}}>
                                {lang.name}
                        </Typography>
                        
                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '10%', fontWeight : 700}}>Header</Typography>
                        <TextField
                            value={header[lang.value]?.header || ''}
                            onChange={(e) => handleHeadingChange(e, lang.value, 'header')}
                            placeholder={`Enter heading for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '10%', fontWeight : 700}}>Address</Typography>
                        <TextField
                            value={header[lang.value]?.address || ''}
                            onChange={(e) => handleHeadingChange(e, lang.value, 'address')}
                            placeholder={`Enter address for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '10%', fontWeight : 700}}>Email</Typography>
                        <TextField
                            value={header[lang.value]?.email || ''}
                            onChange={(e) => handleHeadingChange(e, lang.value, 'email')}
                            placeholder={`Enter email for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '10%', fontWeight : 700}}>Tel</Typography>
                        <TextField
                            value={header[lang.value]?.tel || ''}
                            onChange={(e) => handleHeadingChange(e, lang.value, 'tel')}
                            placeholder={`Enter tel for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '10%', fontWeight : 700}}>Website</Typography>
                        <TextField
                            value={header[lang.value]?.website || ''}
                            onChange={(e) => handleHeadingChange(e, lang.value, 'website')}
                            placeholder={`Enter website for ${lang.name}`}
                        />
                        </Box>

                        <Divider sx={{mt : 2, mb : 2}}/>
                    </Box>
                ))}

                
                <Button sx={{mt : 2}} variant='contained' onClick={() => addHeaderLanguage()}>Add Language</Button>

                <Divider sx={{border : '2px solid gray', mt : 4, mb : 4}}/>

                <Typography sx={{fontSize : '1.5rem', fontWeight : 700}}>Form Names</Typography>

                {activeLanguagesBottomDats.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', flexDirection : 'column',gap: 2, justifyContent : 'flex-start', mt: 2 }}>
                        <Typography sx={{width : '20%', color : 'black', fontWeight : 700, fontSize : '1.2rem'}}>
                                {lang.name}
                        </Typography>
                        
                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Name</Typography>
                        <TextField
                            value={bottomData[lang.value]?.name || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'name')}
                            placeholder={`Enter name for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Name placeholder</Typography>
                        <TextField
                            value={bottomData[lang.value]?.namePlaceHolder || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'namePlaceHolder')}
                            placeholder={`Enter name placeholder for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Name Error Message</Typography>
                        <TextField
                            value={bottomData[lang.value]?.nameErrorMessage || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'nameErrorMessage')}
                            placeholder={`Enter name error message for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>DOB</Typography>
                        <TextField
                            value={bottomData[lang.value]?.dob || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'dob')}
                            placeholder={`Enter dob for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>DOB Error Message</Typography>
                        <TextField
                            value={bottomData[lang.value]?.dobErrorMessage || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'dobErrorMessage')}
                            placeholder={`Enter dob error message for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Nationality</Typography>
                        <TextField
                            value={bottomData[lang.value]?.nationality || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'nationality')}
                            placeholder={`Enter nationality for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Nationality Error message</Typography>
                        <TextField
                            value={bottomData[lang.value]?.nationalityErrorMessage || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'nationalityErrorMessage')}
                            placeholder={`Enter nationality error message for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Contact No</Typography>
                        <TextField
                            value={bottomData[lang.value]?.contact_no || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'contact_no')}
                            placeholder={`Enter contact no for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Contact No Placeholder</Typography>
                        <TextField
                            value={bottomData[lang.value]?.contact_no_placeHolder || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'contact_no_placeHolder')}
                            placeholder={`Enter contact no placeholder for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Contact No Error message</Typography>
                        <TextField
                            value={bottomData[lang.value]?.contact_no_errorMessage || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'contact_no_errorMessage')}
                            placeholder={`Enter contact no error message for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Email</Typography>
                        <TextField
                            value={bottomData[lang.value]?.email || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'email')}
                            placeholder={`Enter email for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Email Placeholder</Typography>
                        <TextField
                            value={bottomData[lang.value]?.emailPlaceHolder || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'emailPlaceHolder')}
                            placeholder={`Enter email placeholder for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Email error message</Typography>
                        <TextField
                            value={bottomData[lang.value]?.emailErrorMessage || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'emailErrorMessage')}
                            placeholder={`Enter email error message for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Line</Typography>
                        <TextField
                            value={bottomData[lang.value]?.line || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'line')}
                            placeholder={`Enter line for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Line Placeholder</Typography>
                        <TextField
                            value={bottomData[lang.value]?.linePlaceholder || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'linePlaceholder')}
                            placeholder={`Enter line placeholder for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Wechat</Typography>
                        <TextField
                            value={bottomData[lang.value]?.wechat || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'wechat')}
                            placeholder={`Enter wechat for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Wechat Placeholder</Typography>
                        <TextField
                            value={bottomData[lang.value]?.wechatPlaceholder || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'wechatPlaceholder')}
                            placeholder={`Enter wechat placeholder for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Whatsapp</Typography>
                        <TextField
                            value={bottomData[lang.value]?.whatsapp || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'whatsapp')}
                            placeholder={`Enter whatsapp for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Whatsapp Placeholder</Typography>
                        <TextField
                            value={bottomData[lang.value]?.whatsappPlaceholder || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'whatsappPlaceholder')}
                            placeholder={`Enter whatsapp placeholder for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Other Remarks</Typography>
                        <TextField
                            value={bottomData[lang.value]?.other_remarks || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'other_remarks')}
                            placeholder={`Enter other remarks for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Other Remarks Placeholder</Typography>
                        <TextField
                            value={bottomData[lang.value]?.other_remarks_placeholder || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'other_remarks_placeholder')}
                            placeholder={`Enter other remarks placeholder for ${lang.name}`}
                        />
                        </Box>

                        <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography sx={{width : '20%', fontWeight : 700}}>Submit</Typography>
                        <TextField
                            value={bottomData[lang.value]?.submit || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'submit')}
                            placeholder={`Enter submit for ${lang.name}`}
                        />
                        </Box>

                        <Divider sx={{mt : 2, mb : 2}}/>
                    </Box>
                ))}

                
                <Button sx={{mt : 2}} variant='contained' onClick={() => addBottomDatasLanguage()}>Add Language</Button>
                
                <Divider sx={{mt : 4, mb: 4, border : '2px solid gray'}} />
                <Button variant='contained' onClick={() => handleSubmit()}>{contactUsData.length > 0 ? 'Update' : 'Save'}</Button>
    </div>
  )
}

export default ContactUsAdmin